export const generateKeyName = ({
  file,
  userId,
  timestamp = Date.now(),
}: {
  // We only need the name of the file
  // this could be a File or UppyFile
  file: { name: string };
  userId: string;
  timestamp?: number;
}): string => {
  return `${userId}/uploads/${timestamp}-${encodeURIComponent(file.name)}`;
};
